import { useEffect, useRef, useState } from 'react';
import { NavLink } from 'react-router-dom';
import testimonials from '../data/testimonials';
import useScreenSize from '../hooks/useScreenSize';
import oval from '../media/OvalBig.png';

// Solo se publican los testimoniales que ya tienen texto real.
const publishedTestimonials = testimonials.filter(({ quote }) => quote.trim() !== '');

/**
 * Carrusel de testimoniales del home.
 *
 * El desplazamiento se calcula midiendo la posición real de la tarjeta
 * (offsetLeft). Antes eran tres valores fijos escritos a mano (0, -315 y -630
 * px) que solo cuadraban en una resolución: en cualquier otra el carrusel
 * quedaba cortado a la mitad. Al depender de `width` el cálculo se rehace
 * cuando cambia el tamaño de la ventana.
 */
const Testimonials = () => {
  const trackRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [offset, setOffset] = useState(0);
  const { width } = useScreenSize();

  useEffect(() => {
    const card = trackRef.current?.children[activeIndex];
    setOffset(card ? card.offsetLeft : 0);
  }, [activeIndex, width]);

  if (publishedTestimonials.length === 0) {
    return null;
  }

  return (
    <div className="testimonials">
      <div className="testimonialsHeader">
        <h3>Testimoniales</h3>
        <p className="textBold">¿Qué opinan de nosotros?</p>
        <NavLink to="/contact" className="btnDark">
          Contáctanos
        </NavLink>
      </div>

      <div className="testimonialsViewport">
        <div
          className="testimonialsTrack"
          ref={trackRef}
          style={{ transform: `translateX(-${offset}px)` }}
        >
          {publishedTestimonials.map(({ id, name, company, photo, quote }) => (
            <figure className="testimonialCard" key={id}>
              <div
                className="testimonialCardImg"
                style={{ backgroundImage: `url(${photo})` }}
                role="img"
                aria-label={`Fotografía de ${name}`}
              />
              <figcaption>
                <h4>{name}</h4>
                <p>{company}</p>
              </figcaption>
              <blockquote className="textContent">{quote}</blockquote>
            </figure>
          ))}
        </div>

        <div className="testimonialsControls">
          {publishedTestimonials.map(({ id, name }, index) => (
            <button
              type="button"
              key={id}
              className={index === activeIndex ? 'testimonialsControlActive' : undefined}
              aria-label={`Ver el testimonial de ${name}`}
              aria-current={index === activeIndex}
              onClick={() => setActiveIndex(index)}
            />
          ))}
        </div>
      </div>

      <div className="testimonialsOval">
        <img src={oval} alt="" />
      </div>
    </div>
  );
};

export default Testimonials;
